import _defineProperty from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapState, mapActions } from 'vuex';
import { getDataByStrucCode as _getDataByStrucCode } from '@api/setting/business';
import Balance from './components/balance';
import StrucTypeComponent from './components/strucType';
import { toThousandsForMates as _toThousandsForMates } from '@/filters';
import { getDetail as _getDetail } from '@api/setting/task/create';
import { getManger, getPartner, getQCPerson as _getQCPerson, getStrucMsg, saveTask, setChildTasks, getChildTasks, getTaskBaseInfo, getAccountList as _getAccountList, delAccount as _delAccount, getMyStruc as _getMyStruc, handleTableBatch as _handleTableBatch } from '@api/correspondence/task';
export default {
  name: 'correspondence-task-create',
  props: {
    id: {},
    lazy: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      officeName: [],
      officeNameLocalStorageName: 'cpscc-task-form-officeName',
      sortBy: undefined,
      userRoles: [],
      template: null,
      searchKey: undefined,
      rules: {
        c01CusName: [{
          required: true,
          message: '请输入客户名称',
          trigger: 'change'
        }],
        c01StrucCode: [{
          required: true,
          message: '请选择主办部门',
          trigger: 'change'
        }],
        c01StartDate: [{
          required: true,
          message: '请选择报告期间',
          trigger: 'change'
        }],
        c01N01Code: [{
          required: true,
          message: '请选择业务类型',
          trigger: 'change'
        }],
        c01StrucType: [{
          required: true,
          message: '请选择作业架构',
          trigger: 'change'
        }],
        c01TaskName: [{
          required: true,
          message: '请输入作业名称',
          trigger: 'change'
        }],
        c01ReportNeed: [{
          required: true,
          message: '请选择是否出具报告',
          trigger: 'change'
        }],
        c01ReportDate: [{
          required: true,
          message: '请选择预计报告日期',
          trigger: 'blur'
        }],
        partners: [{
          required: true,
          message: '请选择主管合伙人',
          type: 'array',
          trigger: 'blur'
        }],
        managers: [{
          required: true,
          message: '请选择主管经理',
          type: 'array',
          trigger: 'blur'
        }],
        leaders: [{
          required: true,
          message: '请选择现场负责人',
          type: 'array',
          trigger: 'blur'
        }],
        // participants: [
        //   {required: true, message: '请选择参与人员', type: 'array', trigger: 'blur'}
        // ],
        quality4: [{
          required: true,
          message: '请选择四级质控人员',
          type: 'array',
          trigger: 'blur'
        }],
        quality5: [{
          required: true,
          message: '请选择五级质控人员',
          type: 'array',
          trigger: 'blur'
        }],
        multipleSelection: [{
          required: true,
          message: '请选择下级',
          type: 'array',
          trigger: 'blur'
        }],
        c01IsPublic: [{
          required: true,
          message: '请选择是否共同处理回函',
          trigger: 'blur'
        }],
        c01FileState: [{
          required: true,
          message: '请选择函证领取状态',
          trigger: 'blur'
        }],
        c01OfficeName: [{
          required: true,
          message: '请输入函件主体事务所',
          trigger: 'blur'
        }]
      },
      form: {
        c01CreateStaff: undefined,
        c01CusName: '',
        c01CusShortName: '',
        c01CusInfo: '',
        c01StrucCode: undefined,
        c01StartDate: undefined,
        c01EndDate: undefined,
        c01N01Code: undefined,
        c01RiskLevel: undefined,
        c01QCLevel: undefined,
        c01StrucType: undefined,
        c01TaskName: '',
        c01ReportNeed: undefined,
        c01ReportDate: undefined,
        c01OfficeName: '',
        c01ReportMapping: undefined,
        leaders: undefined,
        managers: undefined,
        partners: undefined,
        quality4: undefined,
        quality5: undefined,
        inquisitor: undefined,
        participants: undefined,
        c01IsPublic: false,
        c01CreateStaffName: undefined,
        c01CreateDate: undefined,
        c01FileState: undefined,
        c01TaskState: undefined,
        c01UpTaskId: ''
      },
      loading: false,
      upTaskName: '',
      strucCodes: [],
      isLockTackName: true,
      tableData: [],
      defaultTaskId: '00000000-0000-0000-0000-000000000000',
      multipleSelection: [],
      partners: [],
      quality4: [],
      quality5: [],
      mangers: [],
      accountListLoading: false,
      totalPages: 0,
      currentPage: 1,
      pageSize: 10,
      strucList: [],
      selectedList: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('d2admin/page', ['opened', 'current' // 用户获取当前页面的地址，用于关闭
  ])), mapState('cpscc', ['userInfo', 'staffsList', 'levelType', 'levelName', 'levelKey', 'levelNum'])), {}, {
    userId: function userId() {
      if (this.userInfo && this.userInfo.data2) {
        return this.userInfo.data2.userId;
      }
      return undefined;
    },
    isCreator: function isCreator() {
      var role = this.userRoles;
      return role && role.includes('参与人员') && this.form.c01CreateStaff === this.userId;
    },
    isHasPermission: function isHasPermission() {
      return this.$store.getters['cpscc/isHasPermission'](0, this.userRoles) || this.isCreator;
    },
    isHasBasePermission: function isHasBasePermission() {
      return this.$store.getters['cpscc/isHasPermission'](0, this.userRoles);
    },
    isManagersOrPartners: function isManagersOrPartners() {
      return this.$store.getters['cpscc/isHasPermission'](1, this.userRoles);
    },
    isHasQcPermission: function isHasQcPermission() {
      return this.$store.getters['cpscc/isHasPermission'](2, this.userRoles);
    },
    isStaffPermission: function isStaffPermission() {
      return this.$store.getters['cpscc/isHasPermission'](3, this.userRoles);
    },
    strucCodeInfo: function strucCodeInfo() {
      var _this = this;
      return this.strucCodes.find(function (item) {
        return item.n01Code === _this.form.c01N01Code;
      });
    },
    partnerList: function partnerList() {
      var code = this.form.partners;
      var list = this.partners;
      return this.getHistoryStaffInfo(code, {
        name: 'n21StaffName',
        key: 'n21Staff'
      }, list);
    },
    quality4List: function quality4List() {
      var code = this.form.quality4;
      var list = this.quality4;
      return this.getHistoryStaffInfo(code, {
        name: 'n21StaffName',
        key: 'n21Staff'
      }, list);
    },
    quality5List: function quality5List() {
      var code = this.form.quality5;
      var list = this.quality5;
      return this.getHistoryStaffInfo(code, {
        name: 'n21StaffName',
        key: 'n21Staff'
      }, list);
    },
    managerList: function managerList() {
      var code = this.form.managers;
      var list = this.mangers;
      var res = this.getHistoryStaffInfo(code, {
        name: 'n21StaffName',
        key: 'n21Staff'
      }, list);
      return res;
    },
    UpTaskId: function UpTaskId() {
      if (this.form.c01UpTaskId !== this.defaultTaskId && this.form.c01UpTaskId) {
        return this.form.c01UpTaskId;
      }
      return '';
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['close'])), {}, {
    toThousandsForMates: function toThousandsForMates(val) {
      return _toThousandsForMates(val);
    },
    toPercentage: function toPercentage(val) {
      if (!val) {
        return '0%';
      }
      return "".concat((val * 100).toFixed(2), "%");
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedList = val;
    },
    handleTableBatch: function handleTableBatch() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this2.$$confirm('确定删除?');
            case 1:
              _this2.accountListLoading = true;
              _context.n = 2;
              return _this2.$awaitTo(_handleTableBatch(_this2.id, {
                method: 'delete',
                data: _this2.selectedList.map(function (item) {
                  return item.c12Id;
                })
              }));
            case 2:
              _yield$_this2$$awaitT = _context.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.accountListLoading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              _this2.$message.success('操作成功');
              _this2.getAccountList();
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getMyStruc: function getMyStruc() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this3.$awaitTo(_getMyStruc());
            case 1:
              _yield$_this3$$awaitT = _context2.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              data = _yield$_this3$$awaitT2[1].data;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (Array.isArray(data)) {
                _this3.strucList = data;
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    delAccount: function delAccount(id) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$$confirm('确定删除?');
            case 1:
              _context3.n = 2;
              return _this4.$awaitTo(_delAccount(_this4.id, id));
            case 2:
              _yield$_this4$$awaitT = _context3.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 1);
              err = _yield$_this4$$awaitT2[0];
              if (!err) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _this4.$message.success('操作成功');
              _this4.getAccountList();
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    disabledOptions: function disabledOptions(key, type) {
      var partners = this.form.partners;
      var managers = this.form.managers;
      var leaders = this.form.leaders;
      var participants = this.form.participants;
      var quality4 = this.form.quality4;
      var quality5 = this.form.quality5;
      var inquisitor = this.form.inquisitor;
      var options = [];
      if (type !== 'partners' && Array.isArray(partners) && partners.length) {
        options.push.apply(options, _toConsumableArray(partners));
      }
      if (type !== 'managers' && Array.isArray(managers) && managers.length) {
        options.push.apply(options, _toConsumableArray(managers));
      }
      if (type !== 'leaders' && Array.isArray(leaders) && leaders.length) {
        options.push.apply(options, _toConsumableArray(leaders));
      }
      if (type !== 'participants' && Array.isArray(participants) && participants.length) {
        options.push.apply(options, _toConsumableArray(participants));
      }
      if (type !== 'quality4' && Array.isArray(quality4) && quality4.length) {
        options.push.apply(options, _toConsumableArray(quality4));
      }
      if (type !== 'quality5' && Array.isArray(quality5) && quality5.length) {
        options.push.apply(options, _toConsumableArray(quality5));
      }
      // if (type !== 'inquisitor' && Array.isArray(quality5) && quality5.length) {
      //   options.push(...inquisitor)
      // }
      var res = options.find(function (id) {
        return id === key;
      });
      return !!res;
    },
    submit: function submit() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var form, strucType, staffDetails, partners, staffs, list, self, level, type, initStaffInfo, data, _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, res, _yield$_this5$$awaitT3, _yield$_this5$$awaitT4, _err;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              initStaffInfo = function _initStaffInfo(key) {
                var keyName = 'id';
                var valueName = 'name';
                list = staffs;
                if (key === 'partners') {
                  list = partners;
                  keyName = 'n21Staff';
                  valueName = 'n21StaffName';
                  if (key === 'quality4' || key === 'quality5') {
                    list = this[key];
                  }
                }
                var staff;
                if (Array.isArray(form[key])) {
                  form[key].forEach(function (id) {
                    if (self.id) {
                      staff = self.data.staffDetails.find(function (item) {
                        return item.c11Uid === id;
                      });
                    }
                    if (staff) {
                      staffDetails.push(_objectSpread(_objectSpread({}, staff), {}, {
                        c11Role: type[key],
                        c11C01Id: self.id
                      }));
                    } else {
                      var item = list.find(function (item) {
                        return item[keyName] === id;
                      });
                      if (item) {
                        staffDetails.push({
                          c11Uid: item[keyName],
                          c11Name: item[valueName],
                          c11Role: type[key],
                          c11C01Id: self.id
                        });
                      }
                    }
                  });
                }
              };
              _context4.n = 1;
              return _this5.$checkForm();
            case 1:
              form = _this5.form;
              strucType = form.c01StrucType;
              if (!(!form.c01QCLevel || !form.c01RiskLevel)) {
                _context4.n = 2;
                break;
              }
              _this5.$message.error('风险或质控层级不应为空');
              return _context4.a(2);
            case 2:
              staffDetails = [];
              partners = _this5.partners;
              staffs = _this5.staffsList;
              list = [];
              self = _this5;
              level = self.levelType;
              type = self.levelName;
              initStaffInfo('partners');
              initStaffInfo('managers');
              initStaffInfo('leaders');
              initStaffInfo('participants');
              initStaffInfo('quality4');
              initStaffInfo('quality5');
              initStaffInfo('inquisitor');
              if (!form.c01UpTaskId) {
                form.c01UpTaskId = _this5.defaultTaskId;
              }
              data = {
                taskInfo: _objectSpread({}, form),
                staffDetails: staffDetails
              };
              _this5.loading = true;
              _context4.n = 3;
              return _this5.$awaitTo(saveTask(data));
            case 3:
              _yield$_this5$$awaitT = _context4.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              res = _yield$_this5$$awaitT2[1];
              _this5.loading = false;
              if (!err) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2);
            case 4:
              _this5.loading = true;
              if (!(strucType === '合并' && _this5.multipleSelection.length)) {
                _context4.n = 6;
                break;
              }
              _context4.n = 5;
              return _this5.$awaitTo(setChildTasks({
                ParentTaskId: _this5.id,
                ChildTasksJson: JSON.stringify(_this5.multipleSelection)
              }));
            case 5:
              _yield$_this5$$awaitT3 = _context4.v;
              _yield$_this5$$awaitT4 = _slicedToArray(_yield$_this5$$awaitT3, 1);
              _err = _yield$_this5$$awaitT4[0];
              _this5.loading = false;
              if (!_err) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2);
            case 6:
              if (!_this5.officeName.includes(_this5.form.c01OfficeName)) {
                _this5.officeName.push(_this5.form.c01OfficeName);
              }
              localStorage.setItem(_this5.officeNameLocalStorageName, JSON.stringify(_this5.officeName));
              _this5.loading = false;
              _this5.$message.success('操作成功');
              _this5.back();
            case 7:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getHistoryStaffInfo: function getHistoryStaffInfo(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        key: 'n21Staff',
        name: 'n21StaffName'
      };
      var list = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (this.id) {
        var isMultiple = Array.isArray(code);
        var staffsList = this.staffsList;
        var arr = _toConsumableArray(list);
        var ids = arr.map(function (item) {
          return item[options.key];
        });
        var res = list;
        var filterCode = [];
        var newItems = [];
        if (isMultiple) {
          filterCode = code.filter(function (item) {
            return ids.indexOf(item) === -1;
          });
          if (filterCode.length) {
            newItems = staffsList.filter(function (item) {
              return filterCode.indexOf(item.id) !== -1;
            });
            if (newItems.length) {
              newItems = newItems.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, _defineProperty(_defineProperty({}, options.key, item.id), options.name, item.name));
              });
              res.push.apply(res, _toConsumableArray(newItems));
            }
          }
        }
        return res;
      }
      return list;
    },
    selectStrucType: function selectStrucType(type) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var title, tips, _yield$_this6$$awaitT, _yield$_this6$$awaitT2, err, data, ids, _data;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              title = {
                children: '指定下级',
                parent: '指定上级',
                task: '指定作业'
              };
              tips = {
                children: '由于需要多次查询选取作业,勾选作业后点确定,不要退出,继续查选指定的单体作业,暂存后,待全部选取指定后,再呈现出现,最终确认',
                parent: '指定的上级作业只能为合并作业,请输入客户简称查询所有与该客户相关的合并作业,择一指定!',
                task: '提示: 请输入客户简称查选一个作业作为复制创建模板'
              };
              _context5.n = 1;
              return _this6.$awaitTo(_this6.$dialog(StrucTypeComponent, {
                dialog: {
                  title: title[type],
                  width: '700px',
                  tips: tips[type] ? tips[type] : ''
                },
                props: {
                  data: _this6.multipleSelection.filter(function (id) {
                    return id !== _this6.defaultTaskId;
                  }),
                  id: _this6.id,
                  selectId: type === 'parent' ? _this6.form.c01UpTaskId === _this6.defaultTaskId ? undefined : _this6.form.c01UpTaskId : undefined,
                  type: type,
                  name: _this6.form.CusName
                }
              }, function (template) {
                _this6.template = template;
              }));
            case 1:
              _yield$_this6$$awaitT = _context5.v;
              _yield$_this6$$awaitT2 = _slicedToArray(_yield$_this6$$awaitT, 2);
              err = _yield$_this6$$awaitT2[0];
              data = _yield$_this6$$awaitT2[1];
              _this6.template = null;
              if (!err) {
                _context5.n = 2;
                break;
              }
              console.log(err);
              return _context5.a(2);
            case 2:
              ids = data.map(function (item) {
                return item.c01Id;
              });
              if (!(type === 'children')) {
                _context5.n = 3;
                break;
              }
              _this6.multipleSelection = ids;
              _context5.n = 5;
              break;
            case 3:
              if (Array.isArray(ids) && ids.length) {
                _this6.form.c01UpTaskId = ids[0];
              } else {
                _this6.form.c01UpTaskId = _this6.defaultTaskId;
              }
              if (!(_this6.form.c01UpTaskId !== _this6.defaultTaskId)) {
                _context5.n = 5;
                break;
              }
              _context5.n = 4;
              return _this6.getTaskName(_this6.form.c01UpTaskId);
            case 4:
              _data = _context5.v;
              if (Array.isArray(_data) && _data.length) {
                _this6.upTaskName = _data[0].c01CusName + '/' + _data[0].c01TaskName;
              }
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getTaskName: function getTaskName(id) {
      var _arguments = arguments,
        _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var key;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              key = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 'upTaskName';
              return _context7.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(resolve, reject) {
                  var _yield$_this7$$awaitT, _yield$_this7$$awaitT2, err, data;
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        if (id) {
                          _context6.n = 1;
                          break;
                        }
                        reject();
                        return _context6.a(2);
                      case 1:
                        _context6.n = 2;
                        return _this7.$awaitTo(getTaskBaseInfo({
                          TaskIdsJson: JSON.stringify([id])
                        }));
                      case 2:
                        _yield$_this7$$awaitT = _context6.v;
                        _yield$_this7$$awaitT2 = _slicedToArray(_yield$_this7$$awaitT, 2);
                        err = _yield$_this7$$awaitT2[0];
                        data = _yield$_this7$$awaitT2[1];
                        if (!err) {
                          _context6.n = 3;
                          break;
                        }
                        reject(err);
                        return _context6.a(2);
                      case 3:
                        resolve(data.data);
                      case 4:
                        return _context6.a(2);
                    }
                  }, _callee6);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee7);
      }))();
    },
    createItem: function createItem(type, id) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _yield$_this8$$awaitT, _yield$_this8$$awaitT2, err, data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this8.$awaitTo(_this8.$dialog(Balance, {
                dialog: {
                  title: type === 'new' ? '新增' : '编辑',
                  width: '700px'
                },
                props: {
                  type: type,
                  uid: _this8.id,
                  id: id
                }
              }, function (template) {
                _this8.template = template;
              }));
            case 1:
              _yield$_this8$$awaitT = _context8.v;
              _yield$_this8$$awaitT2 = _slicedToArray(_yield$_this8$$awaitT, 2);
              err = _yield$_this8$$awaitT2[0];
              data = _yield$_this8$$awaitT2[1];
              _this8.template = null;
              if (!err) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2);
            case 2:
              _this8.getAccountList();
            case 3:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    getStrucMsg: function getStrucMsg(val) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return _this9.getDataByStrucCode();
            case 1:
              _this9.form.c01N01Code = undefined;
              _this9.form.c01RiskLevel = undefined;
              _this9.form.c01QCLevel = undefined;
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getDataByStrucCode: function getDataByStrucCode() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              return _context1.a(2, new Promise(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(resovle) {
                  var data, list;
                  return _regenerator().w(function (_context0) {
                    while (1) switch (_context0.n) {
                      case 0:
                        _context0.n = 1;
                        return _getDataByStrucCode({
                          StrucCode: _this0.form.c01StrucCode
                        });
                      case 1:
                        data = _context0.v;
                        list = data.data;
                        _this0.strucCodes = list;
                        resovle();
                      case 2:
                        return _context0.a(2);
                    }
                  }, _callee0);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));
          }
        }, _callee1);
      }))();
    },
    back: function back() {
      this.$router.push('/correspondence/task');
      var tagName = this.current;
      this.close({
        tagName: tagName,
        onlyClose: true
      });
    },
    taskTypeChange: function taskTypeChange() {
      var _arguments2 = arguments,
        _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var flag, code, _yield$getStrucMsg, data1, data2;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              flag = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : true;
              code = _this1.strucCodeInfo;
              if (code) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              _this1.form.c01RiskLevel = '';
              _this1.form.c01QCLevel = '';
              _context10.n = 2;
              return getStrucMsg({
                id: _this1.form.c01StrucCode,
                RiskLevel: code.n01Risk
              });
            case 2:
              _yield$getStrucMsg = _context10.v;
              data1 = _yield$getStrucMsg.data1;
              data2 = _yield$getStrucMsg.data2;
              _this1.form.c01RiskLevel = data1;
              _this1.form.c01QCLevel = data2;
              if (flag) {
                _this1.form.quality4 = [];
                _this1.form.quality5 = [];
                _this1.form.managers = [];
                _this1.form.partners = [];
              }
              _this1.getParents();
              _this1.getMangers();
              _this1.getQCPerson();
              if (data2 === '5') {
                _this1.getQCPerson(5);
              }
              if (flag) {
                _this1.updateReportName();
              }
            case 3:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    updateReportName: function updateReportName() {
      var form = this.form;
      var StrucType = form.c01StrucType;
      var TaskType = form.c01N01Code;
      if (form.c01StartDate && form.c01EndDate && StrucType && TaskType) {
        var item = this.strucCodeInfo;
        var name = item ? item.n01Name : '';
        this.form.c01TaskName = "[".concat(this.$options.filters.date(form.c01StartDate, 'yyyy-MM-dd'), "~").concat(this.$options.filters.date(form.c01EndDate, 'yyyy-MM-dd'), "]").concat(name, "[").concat(StrucType, "]");
      }
    },
    getQCPerson: function getQCPerson() {
      var _arguments3 = arguments,
        _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var qCLevel, data, key;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              qCLevel = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : 4;
              _context11.n = 1;
              return _getQCPerson({
                StrucCode: _this10.form.c01StrucCode,
                RiskLevel: _this10.form.c01RiskLevel,
                qCLevel: qCLevel
              });
            case 1:
              data = _context11.v;
              key = {
                4: 'quality4',
                5: 'quality5'
              };
              if (Array.isArray(data.data)) {
                _this10[key[qCLevel]] = data.data;
              }
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    getParents: function getParents() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var _yield$getPartner, partners;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return getPartner({
                StrucCode: _this11.form.c01StrucCode,
                RiskLevel: _this11.form.c01RiskLevel
              });
            case 1:
              _yield$getPartner = _context12.v;
              partners = _yield$getPartner.data;
              _this11.partners = partners;
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    getMangers: function getMangers() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _yield$_this12$$await, _yield$_this12$$await2, err, data;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return _this12.$awaitTo(getManger({
                StrucCode: _this12.form.c01StrucCode,
                RiskLevel: _this12.form.c01RiskLevel
              }));
            case 1:
              _yield$_this12$$await = _context13.v;
              _yield$_this12$$await2 = _slicedToArray(_yield$_this12$$await, 2);
              err = _yield$_this12$$await2[0];
              data = _yield$_this12$$await2[1].data;
              if (!err) {
                _context13.n = 2;
                break;
              }
              return _context13.a(2);
            case 2:
              _this12.mangers = data;
            case 3:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    getDetail: function getDetail() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var _yield$_this13$$await, _yield$_this13$$await2, err, data, form, staffDetails, staffType, _yield$_this13$$await3, _yield$_this13$$await4, err1, data1, _data2;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _this13.loading = true;
              _context14.n = 1;
              return _this13.$awaitTo(_getDetail({
                TaskId: _this13.id
              }));
            case 1:
              _yield$_this13$$await = _context14.v;
              _yield$_this13$$await2 = _slicedToArray(_yield$_this13$$await, 2);
              err = _yield$_this13$$await2[0];
              data = _yield$_this13$$await2[1];
              _this13.loading = false;
              if (!err) {
                _context14.n = 2;
                break;
              }
              return _context14.a(2);
            case 2:
              form = data.data1.taskInfo;
              _this13.userRoles = data.data2.roles;
              _this13.data = JSON.parse(JSON.stringify(data.data1));
              form.c01ReportDate = _this13.$options.filters.date(form.c01ReportDate);
              if (form.c01StartDate && form.c01EndDate) {
                form.c01StartDate = _this13.$options.filters.date(form.c01StartDate);
                form.c01EndDate = _this13.$options.filters.date(form.c01EndDate);
              }
              staffDetails = data.data1.staffDetails;
              if (Array.isArray(staffDetails) && staffDetails.length) {
                staffType = _this13.levelKey;
                staffDetails.forEach(function (item) {
                  if (staffType[item.c11Role]) {
                    if (!Array.isArray(form[staffType[item.c11Role]])) {
                      form[staffType[item.c11Role]] = [item.c11Uid];
                    } else {
                      form[staffType[item.c11Role]].push(item.c11Uid);
                    }
                  }
                });
              }
              _this13.form = form;
              if (!_this13.form.c01StrucCode) {
                _context14.n = 3;
                break;
              }
              _context14.n = 3;
              return _this13.getDataByStrucCode();
            case 3:
              _this13.taskTypeChange(false);
              _context14.n = 4;
              return _this13.$awaitTo(getChildTasks({
                ParentTaskId: _this13.id
              }));
            case 4:
              _yield$_this13$$await3 = _context14.v;
              _yield$_this13$$await4 = _slicedToArray(_yield$_this13$$await3, 2);
              err1 = _yield$_this13$$await4[0];
              data1 = _yield$_this13$$await4[1];
              if (!err1) {
                _context14.n = 5;
                break;
              }
              return _context14.a(2);
            case 5:
              _this13.multipleSelection = data1.data.map(function (item) {
                return item.c01Id;
              });
              if (!_this13.UpTaskId) {
                _context14.n = 7;
                break;
              }
              _context14.n = 6;
              return _this13.getTaskName(form.c01UpTaskId);
            case 6:
              _data2 = _context14.v;
              if (Array.isArray(_data2) && _data2.length) {
                _this13.upTaskName = _data2[0].c01CusName + '/' + _data2[0].c01TaskName;
              }
            case 7:
              return _context14.a(2);
          }
        }, _callee14);
      }))();
    },
    sortChange: function sortChange(_ref3) {
      var prop = _ref3.prop,
        order = _ref3.order;
      var type = {
        descending: 'desc',
        ascending: 'asc'
      };
      if (type[order]) {
        this.sortBy = "".concat(prop, " ").concat(type[order]);
      } else {
        this.sortBy = undefined;
      }
      this.handleCurrentChange(1);
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getAccountList();
    },
    getAccountList: function getAccountList() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var _yield$_this14$$await, _yield$_this14$$await2, err, res, data, headers, pagination;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _this14.accountListLoading = true;
              _context15.n = 1;
              return _this14.$awaitTo(_getAccountList(_this14.id, {
                PageNumber: _this14.currentPage,
                PageSize: _this14.pageSize,
                SortBy: _this14.sortBy,
                SearchQuery: _this14.searchKey !== '' && _this14.searchKey !== undefined ? "c12AccountName.contains(\"".concat(_this14.searchKey, "\")") : undefined
              }));
            case 1:
              _yield$_this14$$await = _context15.v;
              _yield$_this14$$await2 = _slicedToArray(_yield$_this14$$await, 2);
              err = _yield$_this14$$await2[0];
              res = _yield$_this14$$await2[1];
              _this14.accountListLoading = false;
              if (!err) {
                _context15.n = 2;
                break;
              }
              return _context15.a(2);
            case 2:
              data = res.data;
              headers = res.headers;
              if (Array.isArray(data)) {
                _this14.tableData = data;
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this14.totalPages = JSON.parse(pagination).totalCount;
              }
            case 3:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    init: function init() {
      if (this.id) {
        this.getDetail();
        this.getAccountList();
      }
      this.getMyStruc();
    }
  }),
  created: function created() {
    if (!this.lazy) {
      this.init();
    }
    var data = localStorage.getItem(this.officeNameLocalStorageName);
    if (data) {
      var _list = JSON.parse(data);
      if (Array.isArray(_list)) {
        this.officeName = _list;
      }
    }
  }
};